/**
 * Extracts a user-facing message from an Axios error response.
 *
 * FastAPI can return `detail` as either a plain string (custom errors) or an
 * array of validation objects `{ loc, msg, type }`. Arrays (and any other
 * non-string values) are not user-friendly, so we fall back to the provided
 * `fallback` message in that case — keeping toasts readable regardless of
 * what the server sends.
 *
 * When `prefix` is provided and the server returned a usable detail string,
 * the prefix is prepended (e.g. `"Could not upload the script: File too large"`)
 * so the toast retains operation context instead of showing a bare API message.
 *
 * Uses a structural input type rather than `AxiosError<T>` so it works with
 * both strongly-typed mutation errors and untyped `.catch()` errors.
 */
export const getApiErrorMessage = (
  error: { response?: { data?: { detail?: unknown } } } | null | undefined,
  fallback: string,
  prefix?: string,
): string => {
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string' && detail) {
    return prefix ? `${prefix}: ${detail}` : detail
  }
  return fallback
}
